import { Category, Service } from '@common/types';
import { Box } from '@wix/design-system';
import { FC } from 'react';
import CategorySelector from './CategorySelector';
import ServicesList from './ServicesList';

type CategoriesAndServicesProps = {
  categories: Category[];
  selectedServices: Service[];
  selectedIndex: number;
  onCategorySelect: (index: number) => void;
};

const CategoriesAndServices: FC<CategoriesAndServicesProps> = ({
  categories,
  selectedServices,
  selectedIndex,
  onCategorySelect,
}) => {
  return (
    <Box
      dataHook="categories-and-services"
      width="100%"
      display="flex"
      gap="18px"
    >
      <CategorySelector
        categories={categories}
        selectedIndex={selectedIndex}
        onCategorySelect={onCategorySelect}
      />
      <ServicesList services={selectedServices} />
    </Box>
  );
};

export default CategoriesAndServices;
